import React from 'react';
import { InputType } from '../../Form/InputType';
import { RowType } from '../../Form/RowType';
import { Translate } from '@above-the-treeline/localization';
import {
	getLabelAndInputRow as getLabelAndInputRowOptions,
	getLabelAndSelectInputRow as getLabelAndSelectInputRowOptions,
} from '../../Form/Form';

export const getInitialFormValuesById = (org, accountInfoForm) => {
	const initialFormValuesById = {
		accountType: accountInfoForm.selectedAccountType,
		accountName: org.displayName,
		country: org.address.country,
		address1: org.address.streetAddress1,
		address2: org.address.streetAddress2,
		city: org.address.city,
		stateCA: org.address.stateId.toString(),
		stateUS: org.address.stateId.toString(),
		zip: org.address.postalCode,
		phone: org.primaryPhone,
		isAccountSearchable: accountInfoForm.isSearchable,
		orgID: org.orgID,
		orgType: org.orgType,
	};

	return initialFormValuesById;
};

export const getRowOptionsList = accountInfoForm => {
	const rowOptionsList = [
		getLabelAndSelectInputRowOptions(
			<Translate id="account_type" />,
			'accountType',
			accountInfoForm.accountTypes,
		),
		getLabelAndInputRowOptions(
			<Translate id="account_name" />,
			'accountName',
		),
		getLabelAndSelectInputRowOptions(
			<Translate id="country" />,
			'country',
			accountInfoForm.countries,
			true,
		),
		getLabelAndInputRowOptions(
			<>
				<Translate id="address" /> 1
			</>,
			'address1',
		),
		getLabelAndInputRowOptions(
			<>
				<Translate id="address" /> 2
			</>,
			'address2',
		),
		getLabelAndInputRowOptions(<Translate id="city" />, 'city'),
		getStatesSelectRowOptions(accountInfoForm),
		getPostalCodeAndPhoneRowOptions(),
		getIsAccountSearchableRowOptions(),
	];

	return rowOptionsList;
};

const getStatesSelectRowOptions = accountInfoForm => {
	return {
		rowType: RowType.LabelAndInput,
		rowTypeData: {
			label: <Translate id="state" />,
			inputType: InputType.StatesSelect,
			optionsCA: {
				inputId: 'stateCA',
				selectOptions: accountInfoForm.states_CA,
			},
			optionsUS: {
				inputId: 'stateUS',
				selectOptions: accountInfoForm.states_US,
			},
			doShowRow: formValuesById => {
				const validCountries = ['US', 'CA'];
				return validCountries.includes(formValuesById['country']);
			},
		},
	};
};

const getPostalCodeAndPhoneRowOptions = () => {
	return {
		rowType: RowType.PostalCodeAndPhone,
		rowTypeData: {},
	};
};

const getIsAccountSearchableRowOptions = () => {
	return {
		rowType: RowType.IsAccountSearchableForNewUsers,
		rowTypeData: {},
	};
};
